import { render, staticRenderFns } from "./UpdateSubjectsFile.vue?vue&type=template&id=01d959da&"
import script from "./UpdateSubjectsFile.vue?vue&type=script&lang=js&"
export * from "./UpdateSubjectsFile.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSubjectsFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01d959da')) {
      api.createRecord('01d959da', component.options)
    } else {
      api.reload('01d959da', component.options)
    }
    module.hot.accept("./UpdateSubjectsFile.vue?vue&type=template&id=01d959da&", function () {
      api.rerender('01d959da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/flow/UpdateSubjectsFile.vue"
export default component.exports